// import moment from 'moment'
/*
  OSS图片压缩
  @params:{
    src   图片地址
    w     图片宽度（单位upx）
    h     图片高度（单位upx）
  }
*/
function ossImageScale(src, w, h) {
  return `${src}?x-oss-process=image/resize,m_fill,h_${h * 2},w_${ w* 2}`
}

/*
  格式化时间
  @params:{
    time <String> 任何合法的时间格式、秒或毫秒的时间戳
    format <String> 时间格式，可选。默认为yyyy-mm-dd，
                    年为"yyyy"，月为"mm"，日为"dd"，时为"hh"，分为"MM"，秒为"ss"，
                    格式可以自由搭配，如： yyyy:mm:dd，yyyy-mm-dd，yyyy年mm月dd日，yyyy年mm月dd日 hh时MM分ss秒，yyyy/mm/dd/，MM:ss等组合
  }
*/
// function timeFormat(timestamp, format = 'yyyy-mm-dd') {
//   return moment(timestamp).format(format)
// }

function timeFormatMMss(time) {
  let SS = Math.floor(time % 60)
  if (SS < 10) SS = '0' + SS
  let MM = Math.floor(time / 60)
  if (MM < 10) MM = '0' + MM
  return MM + ':' + SS
}

function px2rem(px){
  return `${parseFloat(px) / 75}rem`
}

export default {
  ossImageScale,
  // timeFormat,
  timeFormatMMss,
  px2rem
}
